import React from "react";
import ChatInput from "../ChatInput";

import "./index.css";

const ChatInputPanel = ({
  disabled,
  chatInput,
  setChatInput,
  handleSubmit,
}) => (
  <div className="chat-input-panel">
    <div className="chat-input-panel-container">
      <ChatInput
        disabled={disabled}
        value={chatInput}
        setValue={setChatInput}
        handleSubmit={handleSubmit}
      />
    </div>
  </div>
);

export default ChatInputPanel;
